/**
 * @readonly
 * @enum {string}
 */
export const TpmsStatisticsLpi = Object.freeze({
    MILEAGE_URBAN: 'MILEAGE_URBAN',
    MILEAGE_EXTRA_URBAN: 'MILEAGE_EXTRA_URBAN',
    MILEAGE_MOTORWAY: 'MILEAGE_MOTORWAY'
})
